module.exports = __webpack_public_path__ + "037d830416495def72b7881024c14b7b.woff2";